import { get } from "lodash-es";
import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { ShiftParameters } from "../models/ShiftParameters";

export const getShiftParameters = async (
	assetId: number | null,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "AssetId", value: assetId }];
	const resp = await apiService.callV2(
		"[MES].[GetShiftParameters]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ShiftParameters[];
	} else {
		throw new Error(resp.message || "Error fetching shifts");
	}
};

export const upsertShiftParameters = async (
	{ PatternStart, ShiftCodes, Crews, CrewRotation, Comments }: ShiftParameters,
	assetId: number | null,
	isUpdate = false,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "AssetId", value: assetId },
		{ name: "PatternStart", value: PatternStart },
		{ name: "ShiftCodes", value: ShiftCodes },
		{ name: "Crews", value: Crews },
		{ name: "CrewRotation", value: CrewRotation },
		{ name: "Comments", value: Comments },
		{ name: "IsUpdate", value: isUpdate },
	];

	const resp = await apiService.callV2(
		"[MES].[UpsertShiftParameters]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when upsert shift");
	}
};

export const deleteShiftParameters = async (
	assetId: number | null,
	PatternStart: Date,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "AssetId", value: assetId });
	parameters.push({ name: "PatternStart", value: PatternStart });

	const resp = await apiService.callV2(
		"[MES].[DeleteShiftParameters]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when delete shift");
	}
};
